exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip{background-color:none!important}.useIDAddress{font-size:14px;color:#ff8200;font-weight:500}.useIDAddress:hover{color:#ff8200}", ""]);

// exports
